<template>
  <div class="input-field mb-0">
    <input
      v-model="model"
      type="text"
      :placeholder="placeholder"
      class="!mb-0 lg:min-w-72 xl:min-w-96"
    >
  </div>
</template>

<script setup>
const model = defineModel();

defineProps({
  placeholder: {
    type: String,
    default: 'Search Query',
  },
});
</script>
